module.exports = __webpack_public_path__ + "static/media/CosAssessmentsEveryDeploy4.5b408a89.png";